<div *ngIf="standalone; else loading" class="loading-wrapper">
  <ng-container *ngTemplateOutlet="loading"></ng-container>
</div>

<ng-template #loading>
  <div class="loading" [ngClass]="multipleShipping ? 'multiple-shipping-loading' : ''"></div>
</ng-template>
